import { readAuthorSetupIdentity } from '../../auth/authorSetup';
const URL = 'https://pyvpwlbl5f.execute-api.us-west-2.amazonaws.com/default/newsletterpagesignup';
export function newsletterFields(data) {
  if (!data || typeof data !== 'object' || Array.isArray(data) || typeof data.newsletterTitle !== 'string' || (data.newsletterTagline != null && typeof data.newsletterTagline !== 'string')) throw Error('Saved newsletter settings could not be read safely. Please retry.');
  return { newsletterTitle: data.newsletterTitle, newsletterTagline: data.newsletterTagline || '' };
}
export function createNewsletterApi(identityFor = readAuthorSetupIdentity) {
  let owner;
  async function request(method, value) {
    const identity = await identityFor();
    if (owner && identity.userSub !== owner) throw Error('Your Author account changed. Reload this page before saving.');
    owner = identity.userSub;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    let response, result;
    try {
      response = await fetch(URL, { method, headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + identity.token }, signal: controller.signal, cache: 'no-store', ...(value ? { body: JSON.stringify(value) } : {}) });
      try { result = await response.json(); } catch (error) { if (error.name === 'AbortError') throw error; throw Error('The newsletter service returned an unreadable response. Please retry.'); }
    } catch (error) {
      if (error.name === 'AbortError') throw Error('The request timed out. Reload the saved page to check whether it published before retrying.');
      throw error;
    } finally { clearTimeout(timeout); }
    if (!response.ok) throw Object.assign(Error(result?.message || 'Newsletter settings are unavailable. Please retry.'), { status: response.status });
    newsletterFields(result);
    if (typeof result.version !== 'string' || !result.version) throw Error('The saved newsletter version is unavailable. Reload this page before saving.');
    return result;
  }
  return { get: () => request('GET'), save: value => request('POST', value) };
}
